import { Typography } from "antd";
import { useRef, useEffect, useState } from "react";
import TrustCenterCard from "./TrustCenterCard";
import { getIcon } from "../utils/icons";

const { Title, Paragraph } = Typography;

// Custom Download icon component
const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      d="M7.56831 9.3252C7.58 9.34014 7.59494 9.35222 7.612 9.36053C7.62905 9.36884 7.64778 9.37316 7.66675 9.37316C7.68572 9.37316 7.70444 9.36884 7.7215 9.36053C7.73855 9.35222 7.75349 9.34014 7.76519 9.3252L9.51519 7.11113C9.57925 7.02988 9.52144 6.90957 9.41675 6.90957H8.25894V1.62207C8.25894 1.55332 8.20269 1.49707 8.13394 1.49707H7.19644C7.12769 1.49707 7.07144 1.55332 7.07144 1.62207V6.90801H5.91675C5.81206 6.90801 5.75425 7.02832 5.81831 7.10957L7.56831 9.3252ZM13.3855 8.77832H12.448C12.3792 8.77832 12.323 8.83457 12.323 8.90332V11.3096H3.0105V8.90332C3.0105 8.83457 2.95425 8.77832 2.8855 8.77832H1.948C1.87925 8.77832 1.823 8.83457 1.823 8.90332V11.9971C1.823 12.2736 2.04644 12.4971 2.323 12.4971H13.0105C13.2871 12.4971 13.5105 12.2736 13.5105 11.9971V8.90332C13.5105 8.83457 13.4542 8.77832 13.3855 8.77832Z"
      fill="#8C8C8C"
    />
  </svg>
);

// Custom Lock icon component (for request access)
const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.375C6.83696 2.375 6.20107 2.63839 5.73223 3.10723C5.26339 3.57607 5 4.21196 5 4.875V6.75H10V4.875C10 4.21196 9.73661 3.57607 9.26777 3.10723C8.79893 2.63839 8.16304 2.375 7.5 2.375ZM11.25 6.75V4.875C11.25 3.88044 10.8549 2.92661 10.1516 2.22335C9.44839 1.52009 8.49456 1.125 7.5 1.125C6.50544 1.125 5.55161 1.52009 4.84835 2.22335C4.14509 2.92661 3.75 3.88044 3.75 4.875V6.75H3.125C2.08947 6.75 1.25 7.58947 1.25 8.625V13C1.25 14.0355 2.08947 14.875 3.125 14.875H11.875C12.9105 14.875 13.75 14.0355 13.75 13V8.625C13.75 7.58947 12.9105 6.75 11.875 6.75H11.25ZM3.125 8C2.77982 8 2.5 8.27982 2.5 8.625V13C2.5 13.3452 2.77982 13.625 3.125 13.625H11.875C12.2202 13.625 12.5 13.3452 12.5 13V8.625C12.5 8.27982 12.2202 8 11.875 8H3.125Z"
      fill="#8C8C8C"
    />
  </svg>
);

export default function DeliverableCard({ deliverable, onRequestAccess }) {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkTruncation = () => {
      const element = textRef?.current?.querySelector(".ant-typography");
      if (textRef.current && element) {
        setIsTruncated(element.scrollHeight > element.clientHeight);
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [deliverable.description]);

  const textContent = (
    <Paragraph
      ellipsis={{
        rows: 4,
        tooltip: false,
      }}
      style={{
        color: "#666",
        fontSize: "14px",
        marginBottom: "16px",
        lineHeight: "1.5",
      }}
    >
      {deliverable.description}
    </Paragraph>
  );
  return (
    <TrustCenterCard style={{ height: "280px" }} bodyStyle={{}}>
      <div
        style={{
          width: "64px",
          height: "60px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "12px",
          padding: "8px 0",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        {deliverable.requiresAccess ? getIcon("fileZip") : getIcon("document")}
      </div>
      <Title
        level={4}
        style={{
          marginBottom: "8px",
          marginTop: "0px",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        {deliverable.title}
      </Title>
      <div ref={textRef} style={{ flex: 1, overflow: "hidden" }}>
        {/* {isTruncated ? (
          <Tooltip title={deliverable.description} placement="bottom">
            {textContent}
          </Tooltip>
        ) : (
          textContent
        )} */}
        {textContent}
      </div>
      {deliverable.requiresAccess ? (
        <button
          onClick={() => onRequestAccess(deliverable)}
          style={{
            display: "flex",
            alignItems: "center",
            color: "#999",
            fontSize: "14px",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            transition: "color 0.3s",
            marginTop: "auto",
            flexShrink: 0, // Prevent shrinking
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#666")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
        >
          <span style={{ marginRight: "8px" }}>Request Access</span>
          <LockIcon />
        </button>
      ) : (
        <a
          href={deliverable.downloadUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            color: "#999",
            fontSize: "14px",
            textDecoration: "none",
            transition: "color 0.3s",
            marginTop: "auto",
            flexShrink: 0, // Prevent shrinking
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#666")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
        >
          <span style={{ marginRight: "8px" }}>Download</span>
          <DownloadIcon />
        </a>
      )}
    </TrustCenterCard>
  );
}
